import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { useState } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import Public from "../../Layouts/Public";
import PersonalAppFeatures from "../../components/AppFeatures/PersonalAppFeatures";
import Button from "../../components/Button/Button";
import EarlyBirdOfferModal from "../../components/EarlyBirdOffer/EarlyBirdOfferModal";
import FeatureRow from "../../components/FeatureRow";
import HeroSection, {
  HeroH2,
  HeroH3,
  HeroTitle,
} from "../../components/HeroSection";
import FillerImage from "../../components/Images/FillerImage";
import PageSection, {
  StyledSectionHeading,
} from "../../components/PageSection";
import Spacer from "../../components/Spacer";
import { siteTitle } from "../../data/PublicSiteData";
import { trackPageView } from "../../includes/analytics";
import { Color } from "../../theme/Color";

const Home = () => {
  const router = useRouter();
  const [showConsentModal, setShowConsentModal] = useState(false);

  const heroImage = (
    <img
      src={`/img/app-screenshots/destination-national-network.png`}
      alt="Valmeego.com - Locally and beyond"
      style={{ width: "100%", maxWidth: "338px", height: "auto" }}
    />
  );

  trackPageView("/destination-promoters");

  return (
    <>
      <NextSeo
        title={`Destination Promoters | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />

      {showConsentModal && (
        <EarlyBirdOfferModal
          setShowConsentModal={setShowConsentModal}
          showConsentModal={showConsentModal}
        />
      )}
      <HeroSection
        background={`/img/header-backgrounds/business-header-background-walkers.jpg`}
        image={heroImage}
      >
        <Row center="xs">
          <Col xs={10} sm={10} md={10} lg={12}>
            <Row>
              <HeroTitle>
                Showcase your Destination to a Global Community of Locals and
                Travellers.
              </HeroTitle>
            </Row>
            <Row>
              <HeroH2>
                Cultivate a vibrant and thriving tourism ecosystem for your
                Destination using Valmeego.
              </HeroH2>
            </Row>
            <Row>
              <HeroH3>
                Travellers discover your destination, stay longer, spend more,
                come back again, and recommend it to their friends, family and
                the wider Valmeego community.
              </HeroH3>
            </Row>
            <Row>
              <Col xs={12}>
                <Button
                  dataCy="hero-signup-button"
                  color="primary"
                  label="Sign up"
                  size="extra-large"
                  onClick={() => {
                    router.push("/personal/register");
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </HeroSection>
      {/* Features */}
      <PageSection id="features">
        <Spacer top={4} bottom={10}>
          <Row center="xs" middle="xs">
            <StyledSectionHeading>
              Benefits for Destination Promoters
            </StyledSectionHeading>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Global Reach, Local Charm:">
                Extend your destination's influence to a global audience while
                maintaining its distinctive local allure.
              </FeatureRow>
              <FeatureRow title="Showcase your Destination:">
                Easily showcase all aspects of your locality and provide
                visitors and locals with a comprehensive view of all your
                destination has to offer.
              </FeatureRow>
              <FeatureRow title="Direct booking:">
                Enhance the overall visitor experience with simple direct
                connections and booking with local businesses.
              </FeatureRow>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Row center="xs">
                <Spacer top={3} right={1} bottom={3} left={1}>
                  <FillerImage
                    src={`/img/content/slea-drive.webp`}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={false} sm={6} md={3}>
              <Row>
                <Spacer top={3} right={1} bottom={1} left={1}>
                  <FillerImage
                    src={`/img/content/house-on-cliff.webp`}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Network your Destination:">
                Seamlessly connect the network of local destinations,
                businesses, services, tourism organisations, attractions, tour
                operators and guides to put your destination on the map.
              </FeatureRow>
              <FeatureRow title="Direct Connections:">
                Valmeego facilitates direct interaction between destination
                promoters, locals, and travellers. Easily respond to chat
                enquiries, provide recommendations, and engage directly with
                travellers, enhancing their visitor experience.
              </FeatureRow>
              <FeatureRow title="Engage with a loyal visitor base:">
                Maintain connections with past visitors by providing them with
                captivating content on their Travel Feed ensuring they remain
                connected and inspired to revisit your destination.
              </FeatureRow>
            </Col>
            <Col xs={8} xsOffset={2} sm={false}>
              <Button
                color="primary"
                label="Sign up"
                size="extra-large"
                onClick={() => {
                  router.push("/destination-promoters/register");
                }}
              />
              <Row center="xs" style={{ color: Color.Grey2 }}>
                Valmeego is free to join and use
              </Row>
            </Col>
          </Row>
        </Spacer>
      </PageSection>
      <PersonalAppFeatures />
    </>
  );
};

Home.Layout = Public;
Home.Title = "Valmeego - Locally and beyond";

export default Home;
